import { http } from '../../http';

export default {
    state: {
        companies: [],
        services: [],
        professions: [],
    },

    getters: {
        all: (state) => {
            return state.companies
        },
        services: (state) => {
            return state.services
        },
        professions: (state) => {
            return state.professions
        }
    },

    mutations: {
        setInsuranceCompanies(state, data) {
            state.companies = data;
        },
        setServices(state, data) {
            state.services = data.services
        },
        setProfessions(state, data) {
            state.professions = data.professions
        }
    },

    actions: {

        loadData(context, query_params) {
            context.dispatch('loadInsuranceCompanies', query_params);
            context.dispatch('loadServices', query_params);
        },

        loadInsuranceCompanies({ state, commit }) {
            if (state.companies.length) {
                return;
            }

            return new Promise((resolve, reject) => {
                http.get('/app/settings/apps/digicare/companies')
                    .then(({ data }) => {
                        commit('setInsuranceCompanies', data);
                        resolve(data);  // Let the calling function know that http is done. You may send some data back
                    }, (error) => {
                        // http failed, let the calling function know that action did not work out
                        commit('setInsuranceCompanies', []);
                        reject(error);
                    });
            });
        },

        loadServices({ state, commit }) {
            if (state.services.length) {
                return;
            }

            return new Promise((resolve, reject) => {
                http.get('/app/settings/apps/digicare/services')
                    .then(({ data }) => {
                        commit('setServices', data);
                        commit('setProfessions', data)
                        resolve(data);  // Let the calling function know that http is done. You may send some data back
                    }, (error) => {
                        // http failed, let the calling function know that action did not work out
                        commit('setServices', []);
                        commit('setProfessions', [])
                        reject(error);
                    });
            });
        },
    }
}
